import { GET_PT_SA } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type PastSa = { conversationid: string; created_at: string };

export type PastSaResponseType = {
    success: boolean;
    data: PastSa[];
};

export default (plId: string): Promise<PastSaResponseType> =>
    fetchWithRefresh(GET_PT_SA(plId)).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to fetch pt sa');
        }
    });
